import axios from './config';

export const loginRequest = (email, password) => {
  return axios.post('/auth/login/admin', { email, password });
};

export const logoutRequest = () => {
  return axios.get('/auth/logout');
};

export const recoverCredentials = data => {
  return axios.post('/auth/update', data).then(res => res.data);
};
